import { renderGFM } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/markdown/render_gfm.js?vue3';
export default {
    name: 'FieldView',
    props: {
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    watch: {
        isLoading () {
            this.handleGFM();
        }
    },
    mounted () {
        this.handleGFM();
    },
    methods: {
        handleGFM () {
            if (this.isLoading) return;
            renderGFM(this.$el);
        }
    }
};
